import gql from "graphql-tag";
import { errorsTypeDef } from "../../errors/errors-type-def";
import { removedPayloadTypeDef } from "../../removed-payload/removed-payload-type-def";

const removeDraftMutation = gql`
  mutation removeDraft(
  $id: String!
  ){
    task{
      removePermanentlyDraft(input: {
        id: $id
      }){
        output {
          ${removedPayloadTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }

  }
`;

export default removeDraftMutation;
